import React from "react";
import ReactDOM from "react-dom";
import Template from './Template';
ReactDOM.render(<Template />, document.getElementById('root'));

